import { makeStyles } from "@material-ui/core/styles";
import { deepPurple } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  appBar: {
    width: "100%",
    backgroundColor: "black",
    borderRadius: 15,
    margin: "10px 0",
    // marginTop:'50px',
    display: "flex",
    flexDirection: "row",
    // justifyContent: 'space-between',
    // alignItems: 'center',
    padding: "10px 50px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  heading: {
    color: "#52ab98",
    height: "85px",
    width: "105px"
  },
  image: {
    marginLeft: "11px",
    marginTop: "-2px",
    height: "48px"
  },
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      width: "auto"
    }
  },
  profile: {
    display: "flex",
    justifyContent: "space-between",
    width: "400px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      marginTop: 20,
      justifyContent: "center"
    }
  },
  logout: {
    backgroundColor: "#52ab98",
    marginLeft: "20px"
  },
  userName: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color:"white"
    
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none"
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500]
  }
}));
